
// the components created within this repository
import * as Local_Templates from 'templates/_index';
import * as Local_Components from 'components/_index';
import * as Local_Metas from 'components/_metas';

// general components, from the main lib
import * as General_Components from '@on2-dev/on2-general-resources/components';
import * as General_Metas from '@on2-dev/on2-general-resources/metas';

// lib of components created for a given client and used across projects
import { packages as ClientSpecific } from 'components/_externals';

export const AllTemplates = { Local: Local_Templates };

export const AllMetas = { Local: Local_Metas, General: General_Metas };

export const AllComponents = {
  Local: Local_Components,
  General: General_Components,
};

Object.entries(ClientSpecific || {}).forEach(([pkgName, pkg]) => {
  AllComponents[pkgName] = pkg.components;
  AllMetas[pkgName] = pkg.metas;
});

// export { AllComponents };
